import { Link } from "react-router";

const ADMIN_OPERATIONS = [
  { label: "Regions", description: "View and manage network regions." },
  { label: "Entitlements", description: "Override access levels and limits for users." },
  { label: "Feature flags", description: "Toggle platform features for the rollout." },
] as const;

export function ConsoleAdminPage() {
  return (
    <div className="console-page">
      <div className="console-page-head">
        <h1 className="console-page-title">
          Admin <span className="badge">[Admin]</span>
        </h1>
        <p className="console-page-sub">
          Platform operations. This page is only reachable by users with <strong>admin</strong>{" "}
          access.
        </p>
      </div>

      <div className="admin-grid">
        <section className="panel admin-card">
          <h2 className="panel-title">Global network</h2>
          <p className="page-prose">
            Manage the shared public network — the distributed multi-tenant deployment every
            lite/pro user shares, as opposed to a user's dedicated single-instance server.
          </p>
          <Link to="/console/admin/network" className="btn btn--ghost">
            Manage
          </Link>
        </section>

        {ADMIN_OPERATIONS.map((operation) => (
          <section className="panel admin-card" key={operation.label}>
            <h2 className="panel-title">{operation.label}</h2>
            <p className="page-prose">{operation.description}</p>
            <button type="button" className="btn btn--ghost" disabled>
              Not Implemented
            </button>
          </section>
        ))}
      </div>
    </div>
  );
}
